import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-home-user-segments',
  templateUrl: './home-user-segments.component.html',
  styleUrls: ['./home-user-segments.component.scss']
})
export class HomeUserSegmentsComponent {
  @Input() userSegments: any[] = [];
}